<template>
    <KvModal ref="modal" :id="modalId" size="regular" @close="onClose">
        <template #title>{{ t('invoices-choose_payment_method') }}</template>
        <template #subtitle>{{ t('invoices-choose_payment_method_subtitle') }}</template>
        <template #body>
            <div class="payment-method-options" v-if="invoice">
                <div 
                    v-if="invoice.payment_link_url"
                    class="payment-method-card"
                    @click="payWithLink"
                >
                    <div class="method-card-left">
                        <div class="method-icon-wrapper online-icon">
                            <Icon icon-class="ui-credit-card-refresh" size="4" color="#2aaa4c" />
                        </div>
                        <div class="method-info">
                            <div class="method-title">{{ t('invoices-pay_online_title') }}</div>
                            <div class="method-desc">{{ t('invoices-pay_online_desc') }}</div>
                            <div class="method-badges">
                                <span class="method-badge">{{ t('invoices-badge_credit_card') }}</span>
                                <span class="method-badge highlight">{{ t('invoices-badge_instant') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="method-card-action">
                        <kv-button variant="filled" size="small">
                            {{ t('invoices-pay_online_btn') }}
                        </kv-button>
                    </div>
                </div>

                <div 
                    v-if="invoice.bank_slip_url"
                    class="payment-method-card"
                    @click="payWithSlip"
                >
                    <div class="method-card-left">
                        <div class="method-icon-wrapper slip-icon">
                            <Icon icon-class="ui-file-02" size="4" color="#4B5563" />
                        </div>
                        <div class="method-info">
                            <div class="method-title">{{ t('invoices-pay_slip_title') }}</div>
                            <div class="method-desc">{{ t('invoices-pay_slip_desc') }}</div>
                            <div class="method-badges">
                                <span class="method-badge">{{ t('invoices-badge_bank_slip') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="method-card-action">
                        <kv-button variant="outlined" size="small">
                            {{ t('invoices-view_bank_slip') }}
                        </kv-button>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <kv-button variant="outlined" @click="close">
                {{ t('invoices-cancel') }}
            </kv-button>
        </template>
    </KvModal>
</template>

<script>
import KvModal from "../../components/modal/modal.vue";
import Icon from "../../components/icon/icon.vue";
import KvButton from "../../components/form/kv-button.vue";

export default {
    name: "invoice-payment-method-modal",
    components: {
        KvModal,
        Icon,
        KvButton
    },
    props: {
        modalId: {
            type: String,
            default: "invoice-payment-method-modal"
        },
        invoice: {
            type: Object,
            default: () => null
        }
    },
    methods: {
        open() {
            this.$nextTick(() => {
                if (this.$refs.modal) {
                    this.$refs.modal.open();
                }
            });
        },
        close() {
            if (this.$refs.modal) {
                this.$refs.modal.close();
            }
        },
        onClose() {
            this.$emit("close");
        },
        payWithLink() {
            if (this.invoice && this.invoice.payment_link_url) {
                window.open(this.invoice.payment_link_url, "_blank");
                this.close();
            }
        },
        payWithSlip() {
            if (this.invoice && this.invoice.bank_slip_url) {
                window.open(this.invoice.bank_slip_url, "_blank");
                this.close();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.payment-method-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 8px 0;
}

.payment-method-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: #FFFFFF;

    &:hover {
        border-color: #2aaa4c;
        background-color: #F9FAFB;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);

        .method-title {
            color: #2aaa4c;
        }
    }

    .method-card-left {
        display: flex;
        align-items: flex-start;
        gap: 14px;
    }

    .method-icon-wrapper {
        width: 42px;
        height: 42px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &.online-icon {
            background-color: #ECFDF5;
        }

        &.slip-icon {
            background-color: #F3F4F6;
        }
    }

    .method-info {
        display: flex;
        flex-direction: column;
        gap: 2px;

        .method-title {
            font-size: 14px;
            font-weight: 600;
            color: #111827;
            transition: color 0.15s ease;
        }

        .method-desc {
            font-size: 13px;
            color: #6B7280;
            line-height: 1.4;
        }

        .method-badges {
            display: flex;
            gap: 6px;
            margin-top: 6px;

            .method-badge {
                font-size: 11px;
                font-weight: 500;
                padding: 2px 8px;
                border-radius: 6px;
                background-color: #F3F4F6;
                color: #4B5563;

                &.highlight {
                    background-color: #ECFDF5;
                    color: #065F46;
                }
            }
        }
    }

    .method-card-action {
        flex-shrink: 0;
        margin-left: 12px;
    }
}
</style>
